import { TaskPriorityFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

export function TaskPriority({
  data,
}: {
  data?: Hidable<TaskPriorityFragment>;
}) {
  return (
    <Value data={data}>
      {(task) => <LocalizedName data={task.priority.value} />}
    </Value>
  );
}
